<!-- 這個 DynamicForm 是給後台使用的，由於兩者的顯示風格差異較大，故分成兩個不同版本，不要用錯了 -->
<template>
  <div>
    <!-- FIXME: 這裡照理 hidden 要在 subjects assign to data 時就處理乾淨，不該留在 template 層清洗-->
    <!-- NOTE: 此處的 hidden 相關邏輯為複製 MemberCenterEdit.vue & RegisterMember.vue 的動態編輯欄位相關程式所殘留的邏輯，實際上並未運作，在 DynamicFormEditor 也沒有使用之-->
    <div
      v-for="(subject, index) in subjects.filter((x) => {
        return x.hidden == undefined || !x.hidden;
      })"
      :key="`field.${index}`"
      class="field"
    >
      <!-- type: text start -->
      <template v-if="subject.type === 'text'">
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          :label="subject.title"
          :label-for="subject.id"
        >
          <b-form-input
            :id="subject.id"
            class="mb-2 mr-sm-2 mb-sm-0"
            type="text"
            v-model="form[`${subject.id}`]"
            :state="v$.form[`${subject.id}`].$error ? false : null"
            :disabled="subject.disabled"
            :placeholder="displayPlaceholder(subject)"
          ></b-form-input>
          <b-form-invalid-feedback :state="!v$.form[`${subject.id}`].$error">
            輸入的資料有誤或未填寫，請確認
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
      <!-- type: text end -->

      <!-- type: textarea start -->
      <template v-if="subject.type === 'textarea'">
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          :label="subject.title"
          :label-for="subject.id"
        >
          <b-form-textarea
            :id="subject.id"
            class="mb-2 mr-sm-2 mb-sm-0"
            type="text"
            v-model="form[`${subject.id}`]"
            :placeholder="displayPlaceholder(subject)"
            :disabled="subject.disabled"
            :row="subject.rows"
            :state="v$.form[`${subject.id}`].$error ? false : null"
          ></b-form-textarea>
          <small v-if="subject.memo" class="form-text text-muted">
            {{ subject.memo }}
          </small>
          <b-form-invalid-feedback :state="!v$.form[`${subject.id}`].$error">
            輸入的資料有誤或未填寫，請確認
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
      <!-- type: textarea end -->

      <!-- type: select start -->
      <template v-if="subject.type === 'select'">
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          :label="subject.title"
          :label-for="subject.id"
        >
          <b-form-select
            :id="subject.id"
            v-model="form[`${subject.id}`]"
            :state="v$.form[`${subject.id}`].$error ? false : null"
            :options="optionsWithPlaceholder(subject)"
            :disabled="subject.disabled"
          ></b-form-select>
          <small v-if="subject.memo" class="form-text text-muted">
            {{ subject.memo }}
          </small>
          <b-form-invalid-feedback :state="!v$.form[`${subject.id}`].$error">
            輸入的資料有誤或未填寫，請確認
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
      <!-- type: select end -->

      <!-- type: radio start -->
      <template v-if="subject.type === 'radio'">
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          :label="subject.title"
          :label-for="subject.id"
        >
          <b-form-radio-group
            :id="subject.id"
            v-model="form[`${subject.id}`]"
            :options="availableOptions(subject)"
            :disabled="subject.disabled"
            :state="v$.form[`${subject.id}`].$error ? false : null"
          ></b-form-radio-group>
          <small v-if="subject.memo" class="form-text text-muted">
            {{ subject.memo }}
          </small>
          <b-form-invalid-feedback :state="!v$.form[`${subject.id}`].$error">
            輸入的資料有誤或未填寫，請確認
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
      <!-- type: radio end -->

      <!-- type: checkbox start -->
      <template v-if="subject.type === 'checkbox'">
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          :label="subject.title"
          :label-for="subject.id"
        >
          <b-form-checkbox-group :id="subject.id" v-model="form[`${subject.id}`]">
            <b-form-checkbox
              v-for="(option, optionIndex) in availableOptions(subject)"
              :key="index + '-' + optionIndex"
              :value="option.value"
              :disabled="subject.disabled"
            >
              {{ option.text }}
            </b-form-checkbox>
          </b-form-checkbox-group>
          <small v-if="subject.memo" class="form-text text-muted">
            {{ subject.memo }}
          </small>
          <b-form-invalid-feedback :state="!v$.form[`${subject.id}`].$error">
            輸入的資料有誤或未填寫，請確認
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
      <!-- type: checkbox end -->

      <!-- type: datetime start -->
      <template v-if="subject.type === 'datetime'">
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          :label="subject.title"
          :label-for="subject.id"
        >
          <template v-if="subject.format === 'datetime'">
            <DynamicFormDateTimePicker
              :id="subject.id"
              v-model="form[`${subject.id}`]"
              :placeholder-for-date="displayPlaceholder(subject)"
              :placeholder-for-time="displayPlaceholder(subject) || ' '"
              :has-error="v$.form[`${subject.id}`].$error"
              :daily-time="subject.daily_time"
              :time-condition="subject.time_condition"
              :start-time="subject.start_time"
              :end-time="subject.end_time"
              :slot-minutes="subject.slot_minutes"
              :time-style="subject.time_style"
              :date-condition="subject.date_condition"
              :date-time-options="subject.options"
              :custom-time-options="subject.time_options"
              :optionDisabler="(date, time) => optionDisabler(subject, {date, time})"
              :disabled="subject.disabled"
            />
          </template>
          <template v-if="subject.format === 'date'">
            <DynamicFormDatePicker
              :id="subject.id"
              v-model="form[`${subject.id}`]"
              :placeholder="displayPlaceholder(subject)"
              :has-error="v$.form[`${subject.id}`].$error"
              :disabled="subject.disabled"
            />
          </template>
          <template v-if="subject.format === 'time'">
            <DynamicFormTimePicker
              :id="subject.id"
              v-model="form[`${subject.id}`]"
              :placeholder="displayPlaceholder(subject) || ' '"
              :has-error="v$.form[`${subject.id}`].$error"
              :style-type="subject.time_condition"
              :start-time="subject.start_time"
              :end-time="subject.end_time"
              :slot-minutes="subject.slot_minutes"
              :custom-time-options="subject.time_options"
              :time-style="subject.time_style"
              :disabled="subject.disabled"
            />
          </template>
          <small v-if="subject.memo" class="form-text text-muted">
            {{ subject.memo }}
          </small>
          <b-form-invalid-feedback :state="!v$.form[`${subject.id}`].$error">
            輸入的資料有誤或未填寫，請確認
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
      <!-- type: datetime end -->

      <!-- type: uploader start -->
      <template v-if="subject.type === 'uploader'">
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          :label="subject.title"
          :label-for="subject.id"
        >
          <AppFileUploader v-model="form[`${subject.id}`]" :id="subject.id" :has-error="v$.form[`${subject.id}`].$error" :show-deleted-action="!subject.disabled" />
        </b-form-group>
      </template>
      <!-- type: uploader end -->

      <!-- type: collection_select start -->
      <template v-if="subject.type === 'collection_select'">
        <CollectionSelectDashboard
          :subject="subject"
          :ref="`collection-select-${subject._id}`"
          :branch-id="getBranchIdByFieldId(subject.branch_field_id)"
          :is-related-to-branch="!!subject.branch_field_id"
          v-model="form[`${subject.id}`]"
          :placeholder="displayPlaceholder(subject, '請選擇')"
          :validateError="v$.form[`${subject.id}`].$error"
        ></CollectionSelectDashboard>
      </template>
      <!-- type: collection_select end -->

      <!-- type: collection carousel start -->
      <template v-if="subject.type === 'collection_carousel'">
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          :label="subject.title"
          :label-for="subject.id"
        >
          <CarouselSelection
            :id="subject.id"
            :ref="`collection-carousel-${subject._id}`"
            v-model="form[`${subject.id}`]"
            :placeholder="displayPlaceholder(subject, '請選擇')"
            :candidate-fetcher="() => fetchCollectionItemsForCarousel(subject, subject.branch_field_id)"
            :disabled="subject.disabled || false === carouselSelectionIsEnabled(subject)"
            :value-matcher="matchCandidateForCollectionCarousel"
            :has-error="v$.form[`${subject.id}`].$error">
          </CarouselSelection>
          <small v-if="subject.memo" class="form-text text-muted">
            {{ subject.memo }}
          </small>
          <b-form-invalid-feedback :state="!v$.form[`${subject.id}`].$error">
            輸入的資料有誤或未填寫，請確認
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
      <!-- type: collection carousel end -->

      <!-- type: shop selection start -->
      <template v-if="subject.type === 'shop_selection'">
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          :label="subject.title"
          :label-for="subject.id"
        >
          <ShopSelection
            v-if="deepGet(subject, 'branch_population', 'all') === 'all'"
            :value="deepGet(form[`${subject.id}`], 'value')"
            @selected="(event) => handleShopSelectionChange(event, subject)"
            :ref="`shop-selection-${subject._id}`"
            :branch-provider="subject.branch_provider || ''"
            :show-branch-code="subject.show_branch_code || false"
            :placeholder="subject.default_select_text || '請選擇'"
            :disabled="subject.disabled"
            api-source="admin"
          />
          <ShopSubsetSelection
            v-if="deepGet(subject, 'branch_population', 'all') === 'subset'"
            :value="deepGet(form[`${subject.id}`], 'value')"
            @selected="(event) => handleShopSubsetSelectionChange(event, subject)"
            :ref="`shop-subset-selection-${subject._id}`"
            :branch-ids="subject.branch_ids || ''"
            :show-parent-branches="subject.show_parent_branch_options"
            :parent-branch-population="subject.parent_branch_population || 'parent'"
            :parent-branch-provider="subject.parent_branch_provider || null"
            :show-branch-code="subject.show_branch_code || false"
            :placeholder="subject.default_select_text || '請選擇'"
            :disabled="subject.disabled"
            api-source="admin"
          />
        </b-form-group>
      </template>
      <!-- type: shop selection end -->
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import collectionApi from "@/apis/collection";
import DynamicFormDatePicker from "@/components/DynamicForm/DatePicker.vue";
import DynamicFormDateTimePicker from "@/components/DynamicForm/DateTimePicker.vue";
import AppFileUploader from '@/components/AppFileUploader.vue';
import DynamicFormTimePicker from "@/components/DynamicForm/TimePicker.vue";
import ShopSelection from "@/components/Page/Liff/Branch/ShopSelection";
import ShopSubsetSelection from "@/components/Page/Liff/Branch/ShopSubsetSelection";
import Collection from "@/models/Collection.model.js";
import DynamicFormField from "@/models/DynamicFormField.model"
import DynamicFormValuePresenter from '@/presenters/DynamicFormValue.presenter'
import { validationRules } from '@/utils/DynamicFormUtils';
import CarouselSelection from "./CarouselSelection";
import CollectionSelectDashboard from "./CollectionSelectDashboard.vue";
import deepGet from "lodash/get";

export default {
  components: {
    DynamicFormDatePicker,
    DynamicFormDateTimePicker,
    AppFileUploader,
    DynamicFormTimePicker,
    ShopSelection,
    ShopSubsetSelection,
    CarouselSelection,
    CollectionSelectDashboard,
  },
  props: {
    inputSubjects: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    optionDisabler: {
      type: Function,
      default: (subject, option) => false // eslint-disable-line
    },
  },
  watch: {
    form: {
      handler: function (val) {
        this.$emit("input", val);
      },
      immediate: true,
    },
    value: {
      handler: function (val) {
        this.form = val;
      },
      immediate: true,
    },
  },
  data() {
    return {
      form: this.value || {},
    };
  },
  computed: {
    subjects() {
      return DynamicFormField.fromArray(this.inputSubjects).map(fieldModel => {
        return {
          ...fieldModel.flattenedAttributes(),
          id: fieldModel._id,
        }
      })
    },
  },
  setup: () => ({ v$: useVuelidate({ $lazy: true }) }),
  validations() {
    return {
      form: this.subjects
        .reduce(
          (cumulatedRules, subject) => {
            const rules = {};

            if (subject.required) {
              rules['required'] = required;
            }

            if (subject.validation_rules) {
              const matchedRule = validationRules[subject.type][subject.validation_rules]
              rules[subject.validation_rules] = helpers.withMessage(matchedRule.message, matchedRule.validator);
            }

            return { ...cumulatedRules, [subject.id]: rules }
          },
          {}
        )
    };
  },
  methods: {
    deepGet,
    displayPlaceholder(subject, defaultMessage = null) {
      if (subject.placeholder) return subject.placeholder;
      if (defaultMessage !== null) return defaultMessage;
      return "";
    },
    async validate() {
      const result = await this.v$.$validate();

      if (!result) {
        const element = document.getElementById(this.v$.$errors[0].$property);
        element.scrollIntoView({ behavior: "smooth" });
        console.warn("[DynamicFormDashboard] Validation failed.");
        return false;
      }

      return true;
    },
    availableOptions(subject) {
      const dataModel = new DynamicFormField(subject)
      return dataModel.options
        .map(option => ({
          text: dataModel.availableOptionsForCustomer.includes(option) ? option.text : `${option.text} (前台隱藏)`,
          value: option.value,
        }))
    },
    optionsWithPlaceholder(subject) {
      const options = this.availableOptions(subject)
      if (subject.placeholder) {
        options.unshift({ text: subject.placeholder, value: null })
      }
      return options
    },
    carouselSelectionIsEnabled(subject) {
      return false === (!!subject[`branch_field_id`] && !this.getBranchIdByFieldId(subject[`branch_field_id`]))
    },
    async fetchCollectionItemsForCarousel(subject, fieldId) { // NOTE: 若 DynamicForm 與 DynamicFormDashboard 需要合併，則將此段邏輯改以 vue provide/inject 方式實作
      try {
        let collection;
        const isRelatedToBranch = !!fieldId
        if (isRelatedToBranch) {
          if (this.getBranchIdByFieldId(fieldId)) {
            collection = deepGet(await collectionApi.getOptionsForBranch(subject.collection_id, this.getBranchIdByFieldId(fieldId)), 'data.data', null);
          } else {
            return []
          }
        } else {
          collection = deepGet(await collectionApi.getCollection(subject.collection_id), 'data.data', null)
        }
        const collectionModel = new Collection(collection)

        const getValueFromCollectionItemByFieldId = (collectionItem, fieldId) => {
          if (fieldId === 'default') {
            return collectionModel.textForOption(collectionItem.id)
          }
          return deepGet(collectionItem.data.find(field => field.field_id === fieldId), 'value', null)
        }

        return collection.items.sort((a, b) => a.order - b.order).map((item) => ({
          id: item.id,
          title: getValueFromCollectionItemByFieldId(item, subject[`collection_title`]),
          image: getValueFromCollectionItemByFieldId(item, subject[`collection_image`]),
          description: getValueFromCollectionItemByFieldId(item, subject[`collection_description`]),
          value: DynamicFormValuePresenter.collectionItem(subject, item, collection),
          placeholderWhenSelected: collectionModel.textForOption(item.id),
        }))
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", `讀取 ${subject.title} 選項時發生錯誤，請重新整理後再試一次`, "error")
        return []
      }
    },
    matchCandidateForCollectionCarousel(candidate, incomingValue) {
      if (Array.isArray(incomingValue)) {
        return deepGet(candidate, 'value.collection_id') === deepGet(incomingValue[0], 'collection_id') &&
          deepGet(candidate, 'value.collection_item_id') === deepGet(incomingValue[0], 'collection_item_id')
      } else {
        return deepGet(candidate, 'value.collection_id') === deepGet(incomingValue, 'collection_id') &&
          deepGet(candidate, 'value.collection_item_id') === deepGet(incomingValue, 'collection_item_id')
      }
    },
    async prepareBranchBondCollectionItems() {
      return await Promise.all(
        this.inputSubjects
          .filter(subject => subject.type === 'shop_selection')
          .map(subject => {
            this.updateCollectionItemsByBranchFieldId(subject._id)
          })
      )
    },
    async prepareOptionsForShopSelections() {
      await Promise.all(
        this.inputSubjects
          .filter(subject => subject.type === 'shop_selection')
          .map(subject => {
            if (deepGet(subject, 'branch_population', 'all') === 'all') {
              this.$refs[`shop-selection-${subject._id}`][0].fetchBranchesOptions()
            }
            if (deepGet(subject, 'branch_population', 'all') === 'subset') {
              this.$refs[`shop-subset-selection-${subject._id}`][0].fetchBranchesOptions()
            }
          })
      )
    },
    async prepareOptionsForCollectionSelects() {
      await Promise.all(
        this.inputSubjects
          .filter(subject => subject.type === 'collection_select' && !subject.branch_field_id)
          .map(subject => {
            this.$refs[`collection-select-${subject._id}`][0].fetchCollectionItems()
          })
      )
    },
    handleShopSelectionChange(event, subject) {
      if (event.type === 'shop') {
        this.$set(this.form, subject.id, {
          branch_provider: subject.branch_provider,
          text: deepGet(event, 'model.name'),
          value: deepGet(event, 'model.id'),
        })
      } else {
        this.$set(this.form, subject.id, null)
      }

      this.$nextTick(() => {
        this.updateCollectionItemsByBranchFieldId(subject._id)
      })
    },
    handleShopSubsetSelectionChange(shopModel, subject) {
      if (shopModel === null) {
        this.$set(this.form, subject.id, null)
      } else {
        this.$set(this.form, subject.id, {
          text: deepGet(shopModel, 'name'),
          value: deepGet(shopModel, 'id'),
        })
      }

      this.$nextTick(() => {
        this.updateCollectionItemsByBranchFieldId(subject._id)
      })
    },
    async updateCollectionItemsByBranchFieldId(fieldId) {
      const relatedCollectionSelects = this.inputSubjects.filter(inputSubject => inputSubject.branch_field_id === fieldId)
      relatedCollectionSelects.filter(collectionSelect => collectionSelect.type === 'collection_select')
        .map(collectionSelect => {
          this.$refs[`collection-select-${collectionSelect._id}`][0].fetchCollectionItems()
        })
      relatedCollectionSelects.filter(collectionCarousel => collectionCarousel.type === 'collection_carousel')
        .map(collectionCarousel => {
          this.$refs[`collection-carousel-${collectionCarousel._id}`][0].fetchCandidates()
        })
    },
    getBranchIdByFieldId(fieldId) {
      return deepGet(this.form, `${fieldId}.value`, null)
    },
    // public api: prepare options for shop selection, shop subset selection, collection select, collection carousel
    // recommend: calling this method once after inputSubjects and form are set
    async fetchAllAsyncOptions() {
      await Promise.all([
        this.prepareOptionsForShopSelections(),
        this.prepareBranchBondCollectionItems(),
        this.prepareOptionsForCollectionSelects(),
      ])
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/shared/components/_fields.scss";

body {
  --liff-button-color: #cccccc;
}

.field {
  &__label {
    font-size: 20px;
  }
  &__input {
    font-size: 18px;
    background-color: #ffffff;
  }

  &__desc {
    font-size: 16px !important;
  }

  *[id] {
    scroll-margin-top: 61px; // NOTE: height of header
  }
}

.row {
  margin: 0 -0.5rem;
}

textarea {
  resize: vertical !important;
}
</style>
